import { render, staticRenderFns } from "./JsfzrGcyjForm.vue?vue&type=template&id=6b2d6c23&scoped=true"
import script from "./JsfzrGcyjForm.vue?vue&type=script&lang=js"
export * from "./JsfzrGcyjForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2d6c23",
  null
  
)

export default component.exports